'use client';

import Reveal from './Reveal';
import Image from 'next/image';

export default function McpExplainer() {
  return (
    <section id="mcp" className="bg-gray-50 border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <Reveal>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">MCPとは？</h2>
        </Reveal>
        <Reveal className="mt-3">
          <p className="text-gray-800 max-w-3xl">
            MCPは、あなたの質問にあわせて税務に必要なツールを自動的に呼び出し、計算や照会を通じて回答を補強する仕組みです。今回は東京都の税務に絞り、実務目線で使える内容に。
          </p>
        </Reveal>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-6">
          <Reveal>
            <div className="bg-white rounded-lg border p-4">
              <div className="flex items-center gap-3">
                <Image src="/globe.svg" alt="質問する" width={28} height={28} />
                <h3 className="font-semibold">質問する</h3>
              </div>
              <p className="mt-2 text-gray-700 text-sm">自然な言葉で税務の疑問を投げかけてください。</p>
            </div>
          </Reveal>
          <Reveal>
            <div className="bg-white rounded-lg border p-4">
              <div className="flex items-center gap-3">
                <Image src="/window.svg" alt="MCPがツール呼び出し" width={28} height={28} />
                <h3 className="font-semibold">MCPがツール呼び出し</h3>
              </div>
              <p className="mt-2 text-gray-700 text-sm">計算や照会など、必要な機能を自動で活用します。</p>
            </div>
          </Reveal>
          <Reveal>
            <div className="bg-white rounded-lg border p-4">
              <div className="flex items-center gap-3">
                <Image src="/file.svg" alt="回答を補強" width={28} height={28} />
                <h3 className="font-semibold">回答を補強</h3>
              </div>
              <p className="mt-2 text-gray-700 text-sm">東京都税務に限定した根拠に基づいて、回答を強化します。</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
